import { SVGProps } from 'react';

const SkipBackwardIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <g transform="scale(-1, 1) translate(-20, 0)">
      <path
        d="M18.0227 1.98543L18.0227 6.98572L17.4417 6.98572L13.0227 6.98572"
        fill="currentColor"
      />
      <path
        d="M17.3238 6.63827C15.7274 3.1568 11.8088 1.23086 7.98513 2.25615C3.71709 3.40062 1.1837 7.78883 2.32664 12.0575C3.46958 16.3262 7.85605 18.8588 12.1241 17.7144C13.9749 17.2181 15.4995 16.1118 16.5396 14.6699"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </g>
  </svg>
);

export default SkipBackwardIcon;
